import { GetSessionFilesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface SessionProps {
  sessionId?: number
  trainingId?: number
  visibility?: boolean
  ids?: number[]
}
export const useSessionFiles = ({ sessionId, trainingId, visibility, ids }: SessionProps) => {
  const { loading, data } = useQuery(GetSessionFilesDocument, {
    variables: { sessionId, trainingId, visibility, ids },
  })

  return {
    loading,
    sessionFiles: data ? data.trainings.sessionFilesConnection.nodes : [], // Provide a default value
  }
}
